/*
 * 版权: Copyright (c) 2018 red
 * 
 * 文件: serverJsonRpc.ts
 * 创建日期: Monday July 9th 2018
 * 作者: pao
 * 说明: json rpc的调用和服务
 * 1、json rpc的调用
 * 2、json rpc服务
 */
import { addon, ProxyFactory, IType, jsonRpcCall } from 'pao-aop';
import { postRequest, HttpPostClientAdapter } from './index';

/**
 * 远程工厂
 * @author pao
 * @remark 通过Promise对象进行远程调用的工厂
 */
@addon('AjaxRemoteFactory', '异步工厂', '通过Promise对象进行远程调用的工厂')
export class JsonRpcFactory extends ProxyFactory {
    constructor(destObject?: IType<any> | Object, public url?: string, public serviceName?: string) {
        super(destObject);
    }
    proxyMethod?(methodName: any, args: any): any {
        let that = this;
        return jsonRpcCall(new HttpPostClientAdapter(), that.url!, `${that.serviceName!}.${methodName}`, args);
    }
}